import callApi, { METHOD_TYPE } from '../utils/callApi'
import { DOMAIN } from '../mutations'
import { cloneDeep } from 'lodash'
import { domainFormat } from '../constants'

// 代入されるアクションリストの雛形
const state = {
  domain: {},
  domainlist: []
}

const mutations = {
  [DOMAIN.DOMAIN_LIST](state, payload) { state.domainlist = payload },
  [DOMAIN.DOMAIN_GET](state, payload) { state.domain = payload }
}
const actions = {
  createdomain({ commit }, router) {
    let createparams = {
      fqdn: state.domain.fqdn,
      metadata: state.domain.metadata
    }
    callApi('/delivery/create-domain', METHOD_TYPE.POST, createparams)
    .then((response) => {
      alert('ドメインの作成に成功しました')
      router.push('/delivery/list-domain')
    })
    .catch(e => {
      if (e.response == null) {
        alert('ドメインの作成に失敗しました。' + '\n' + e.message)
      } else {
        alert('ドメインの作成に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  getDomainListData({ commit }) {
    callApi('/delivery/list-domain', METHOD_TYPE.POST, {})
    .then((response) => {
      commit(DOMAIN.DOMAIN_LIST, response.body.domains)
    })
    .catch(e => {
      if (e.response == null) {
        alert('ドメインの取得に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('ドメインの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  getDomainData({ commit }) {
    callApi('/delivery/get-domain', METHOD_TYPE.POST, {'fqdn': state.domain.fqdn})
    .then((response) => {
      commit(DOMAIN.DOMAIN_GET, response.body.domain)
    })
    .catch(e => {
      if (e.response == null) {
        alert('ドメインの取得に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('ドメインの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  formatDomainData({ commit }) {
    commit(DOMAIN.DOMAIN_GET, cloneDeep(domainFormat))
  },
  updateDomain({ commit }, router) {
    // paramsをここで作る。もっと頭のいい方法があったら変更する。
    let updateparams = {
      fqdn: state.domain.fqdn,
      versionId: state.domain.versionId,
      metadata: state.domain.metadata
    }
    callApi('/delivery/update-domain', METHOD_TYPE.POST, updateparams)
    .then((response) => {
      alert('ドメインの更新に成功しました')
      router.push('/delivery/list-domain')
    })
    .catch(e => {
      if (e.response == null) {
        alert('ドメインの更新に失敗しました。' + '\n' + e.message)
      } else {
        alert('ドメインの更新に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  domainDelete({ commit }, domain) {
    callApi('/delivery/delete-domain', METHOD_TYPE.POST, { fqdn: domain.fqdn, versionId: domain.versionId })
    .then((response) => {
      commit(DOMAIN.DOMAIN_LIST, state.domainlist.filter(n => n !== domain))
    })
    .catch(e => {
      if (e.response == null) {
        alert('ドメインの削除に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('ドメインの削除に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  }
}

export default {state, actions, mutations}



// WEBPACK FOOTER //
// ./src/stores/domain.js